module.exports = __webpack_public_path__ + "static/media/agreement.925931bf.png";